/**
 * GEÇİCİ (DEV-2566): "Açılmış takibin hash'i silinemez" kısıtı, hash sisteminde
 * yapılacak değişiklik süresince kapatıldı.
 *
 * Kısıt kapalıyken açıldı durumundaki kayıtlarda da çöp kutusu butonu görünür ve
 * onay diyaloğunda ACILMIS_TAKIP_SILME_UYARISI çıkar. Bakım bitince aşağıdaki değer
 * true yapılarak DEV-2566 davranışına dönülür, başka bir değişiklik gerekmiyor.
 *
 * Not: Sunucu tarafındaki kısıt ayrıdır; bu bayrak yalnızca arayüzü etkiler.
 * Sunucu silmeyi reddederse hashKaydiniSil (HashSilmeHelper) zaten hata fırlatır.
 *
 * Kısıtın uygulandığı yerler:
 *   - src/helpers/HashSilmeHelper.ts hashSilmeKilitli (5 detay ekranı: *IslemDetayView.vue)
 *   - src/components/forms/form-wizard/eicrapro/takip-hazirla/columns/ActionsColumn.vue
 */
export const ACILMIS_TAKIP_SILME_KISITI_AKTIF: boolean = false;

/**
 * Kısıt geçici olarak kapalıyken açılmış takiplerin silme onayında gösterilen uyarı.
 * Diğer kayıt durumlarının metinleri: HashSilmeHelper.kayitDurumuUyarisi (DEV-3302).
 */
export const ACILMIS_TAKIP_SILME_UYARISI =
    "Bu takip UYAP'ta açılmıştır. Hash kaydını silmek takibi iptal etmez; aynı dosya yeniden " +
    "gönderilirse aynı borç için ikinci bir takip açılabilir ve harç yeniden ödenebilir. " +
    "Emin olmadan silmeyiniz.";
